<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case :opq-if="estSituation1ou2" code="declaration-1" v-model="sasNeuropsy.attestationDelivrance" :live="liveSasNeuropsy(7607)"></opq-case>
    <opq-case
      :opq-if="estSituation(3)"
      code="declaration-2"
      v-model="sasNeuropsy.attestationDispenseFormation"
      :live="liveSasNeuropsy(7608)"
    ></opq-case>
    <opq-case code="declaration-3" v-model="sasNeuropsy.attestationEchange" :live="liveSasNeuropsy(7609)"></opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelpers from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasNeuropsy() {
      return this.sas.sasNeuropsy
    },
    estSituation1ou2() {
      return this.estSituation(1) || this.estSituation(2)
    }
  },

  methods: {
    liveSasNeuropsy(cle) {
      return { endpoint: "sas-neuropsy", cle: cle, fileId: this.sasNeuropsy.id }
    },

    estSituation(codeSituation) {
      return this.getCatalogueCodeById(7808, this.sas.sasNeuropsy.situation) == codeSituation
    }
  }
}
</script>

<style>
</style>